import { usePatchAvocadoMutation } from "../../../hooks/mutations";

export default function usePatchAvocado() {
    const patchAvocadoMutation = usePatchAvocadoMutation();
    return (avocado, field, value, callApi = true) => {
        return patchAvocadoMutation.mutateAsync({ avocado, field, value, callApi });
    };
}
